import { Toolbar } from '@mui/material';
import { styled } from '@mui/system';

export const PageTabsWrapper = styled(Toolbar)(({ theme }) => ({
    borderWidth: 0,
    borderBottomWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.divider
  })
);